<template>
  <div>
    <PageAllow
      controller="PresaleTemplates"
      action="index"
      :prohibit="settings && !settings.presale_enable"
    />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <v-text-field
                v-model="templateNameSearch"
                :label="$t('Template.Fields.template_name')"
                clearable
              ></v-text-field>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="getTemplatesFromAPI()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="templateNameSearch = ''"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('PresaleTemplates', 'add')"
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("PreSell.presaleTemplates")]) }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('PresaleTemplates', 'import')"
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1 float-end"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Import.import", [$t("PreSell.presaleTemplates")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="templates"
            :loading="loading"
            :search="templateNameSearch"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.price_setting="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.shop_count="{ item }">
              <a
                v-if="item.shop_count > 0"
                class="text-no-wrap"
                :href="'/#/shops?template_id=' + item.id"
              >
                {{ item.shop_count }}
              </a>
              <span v-else>
                {{ item.shop_count }}
              </span>
            </template>
            <template v-slot:item.price_setting="{ item }">
              <v-btn
                small
                color="info"
                dark
                class="px-2 me-2"
                :href="'/#/pre-sell/' + (item && item.id ? item.id : 0)"
              >
                <v-icon x-small class="px-1">fa-align-left</v-icon>
                {{ $t("Opt.details") }}
              </v-btn>
              <v-btn
                small
                color="primary"
                dark
                class="px-2 me-2"
                :href="
                  '/#/pre-sell/' + (item && item.id ? item.id : 0) + '/edit'
                "
              >
                <v-icon x-small class="px-1">fa-highlighter</v-icon>
                {{ $t("CRUD.update") }}
              </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip
                top
                v-if="$permission.permissionAllow('PresaleTemplates', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-if="item.id"
                    v-bind="attrs"
                    v-on="on"
                    color="accent"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.editInfo", [$t("Template.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('PresaleTemplates', 'copy')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-if="item.id"
                    v-bind="attrs"
                    v-on="on"
                    color="warning"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'clone';
                      currentItem = item;
                    "
                    >fa-clone
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.cloneInfo", [$t("Template.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-if="item.id && item.shop_count == 0"
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.deleteInfo", [$t("Template.ObjectName")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <Template
      v-model="currentItem"
      :mode="currentItemMode"
      @mode="currentItemMode = $event"
      @save="getTemplatesFromAPI()"
    />
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('PreSell.presaleTemplates')"
      @confirm="
        deleteTemplate();
        deleteDialog = false;
      "
    />
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('PreSell.presaleTemplates')"
      @import="
        excelFile = $event;
        importExcel();
      "
      downloadFromAPI
      @download="
        sub_account_type = $event;
        excelExport();
      "
    />
    <v-dialog v-model="errDialog" max-width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("Template.import_err_title") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="errDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-data-table
            :headers="errHeaders"
            :items="errorData"
            multi-sort
            class="elevation-1 px-4 pt-2"
            disable-pagination
            hide-default-footer
            fixed-header
          >
            <template v-slot:item.error_msg="{ item }">
              <span class="red--text">
                {{ item.error_msg }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="errDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import consts from "@/consts";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Template from "./plugins/Template";
import DialogDelete from "@/components/plugins/DialogDelete";
import PresaleTemplates from "@/api/presale_templates";
import ImportExcelAlert from "./plugins/ImportExcelAlert";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Template,
    DialogDelete,
    ImportExcelAlert,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        href: "/materials",
      },
      {
        text: i18n.t("Nav.PreSell"),
        disabled: true,
        href: "/templates",
      },
    ],
    headers: () => [
      {
        text: i18n.t("Template.Fields.template_name"),
        align: "start",
        sortable: true,
        filterable: true,
        value: "template_name",
      },
      {
        text: i18n.t("Template.Fields.material_count"),
        align: "center",
        sortable: false,
        filterable: false,
        value: "material_count",
      },
      {
        text: i18n.t("Template.Fields.shop_count", [consts.shopName()]),
        align: "center",
        sortable: false,
        filterable: false,
        value: "shop_count",
      },
      {
        text: i18n.t("Template.Fields.price_setting"),
        align: "start",
        sortable: false,
        filterable: false,
        value: "price_setting",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        filterable: false,
        value: "actions",
      },
    ],
    errHeaders: () => [
      {
        text: i18n.t("Template.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("Template.Fields.template_name"),
        align: "start",
        sortable: false,
        value: "template_name",
      },

      {
        text: i18n.t("Template.Fields.error_msg"),
        align: "start",
        sortable: false,
        value: "error_msg",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getTemplatesFromAPI();
  },

  data: () => ({
    templateNameSearch: "",
    templates: [],
    currentItem: null,
    currentItemMode: null,
    deleteDialog: false,
    excelFile: null,
    ImportDialog: false,
    errDialog: false,
    errorData: [],
    sub_account_type: null,
  }),

  methods: {
    getTemplatesFromAPI() {
      PresaleTemplates.fetch().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.templates = response.data.presale_templates;
          }
        }.bind(this)
      );
    },
    deleteTemplate() {
      if (this.currentItem) {
        this.$store.dispatch("fullscreenLoading");
        PresaleTemplates.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getTemplatesFromAPI(); // 删除成功的话刷新数据
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
    excelExport() {
      this.$store.dispatch("fullscreenLoading");
      if (
        this.settings &&
        this.settings.sub_account_enable == 1 &&
        this.settings.sub_account_split_type === 0 &&
        !this.sub_account_type
      ) {
        this.$store.dispatch("fullscreenLoadingStop");
        this.$snackbar.error(i18n.t("Template.chooseSubAccountTypeHint"));
      } else {
        var data = {};
        if (
          this.settings &&
          this.settings.sub_account_enable == 1 &&
          this.settings.sub_account_split_type === 0
        ) {
          data = Object.assign({}, data, {
            sub_account_type: this.sub_account_type.type,
          });
        }
        PresaleTemplates.Export(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(i18n.t("Export.recordedHint"));
              this.sub_account_type = null;
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        );
      }
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      if (
        this.settings &&
        this.settings.sub_account_enable == 1 &&
        this.settings.sub_account_split_type === 0 &&
        !this.excelFile.sub_account_type
      ) {
        this.$store.dispatch("fullscreenLoadingStop");
        this.$snackbar.error(i18n.t("Template.chooseSubAccountTypeHint"));
      } else {
        var data = new FormData();
        data.append("excel", this.excelFile.excel);
        if (
          this.settings &&
          this.settings.sub_account_enable == 1 &&
          this.settings.sub_account_split_type === 0
        ) {
          data.append("sub_account_type", this.excelFile.sub_account_type.type);
        }
        PresaleTemplates.Import(data)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                if (response.data.data && response.data.data.length) {
                  this.ImportDialog = false;
                  this.errDialog = true;
                  this.errorData = response.data.data;
                } else {
                  this.$snackbar.info(
                    i18n.t("Import.success", [
                      i18n.t("PreSell.presaleTemplates"),
                    ])
                  );
                  this.ImportDialog = false;
                  this.getTemplatesFromAPI();
                }
                this.excelFile = null;
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>